// src/components/Navbar.tsx
import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const auth = useContext(AuthContext);

  // If AuthContext isn't available for some reason, render nothing
  if (!auth) return null;

  const { user, logout } = auth;

  const navbarStyle: React.CSSProperties = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px 20px",
    backgroundColor: "#003e6b",
    color: "#fff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  };

  const leftStyle: React.CSSProperties = { flex: 1, textAlign: "left" };
  const centerStyle: React.CSSProperties = {
    flex: 1,
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "18px",
  };
  const rightStyle: React.CSSProperties = { flex: 1, textAlign: "right" };

  // Button color switches: green for Login, red for Logout
  const authButtonStyle: React.CSSProperties = {
    padding: "5px 10px",
    backgroundColor: user ? "red" : "green",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginLeft: "10px",
  };

  const dashboardButtonStyle: React.CSSProperties = {
    padding: "5px 10px",
    backgroundColor: "green",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    marginLeft: "10px",
  };

  // Handler for Login/Logout button
  const handleAuthClick = async () => {
    if (user) {
      await logout();
      navigate("/login");
    } else {
      navigate("/login");
    }
  };

  return (
    <nav style={navbarStyle}>
      <div style={leftStyle}>
        <Link to="/">
          <img
            src="/orlogo.png"
            alt="Orchard-Rite Logo"
            style={{ height: "30px" }}
          />
        </Link>
      </div>

      <div style={centerStyle}>Market Insights</div>

      <div style={rightStyle}>
        <button
          style={dashboardButtonStyle}
          onClick={() => navigate("/")}
        >
          Dashboard
        </button>

        <button style={authButtonStyle} onClick={handleAuthClick}>
          {user ? "Logout" : "Login"}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
